import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import * as React from "react";
import "./ProductModal.scss";

interface IPayloadProps {
  title: string;
  value: string;
  isObj?: boolean;
  isNum?: boolean;
}

const IMAGES_URL = process.env.IMAGES_URL;

const payloadBody: IPayloadProps[] = [
  { title: "Ncm", value: "ncm" },
  { title: "Sku", value: "sku" },
  { title: "Cest", value: "cest" },
  { title: "Isbn", value: "isbn" },
  { title: "Peso", value: "peso", isNum: true },
  { title: "Altura", value: "altura", isNum: true },
  { title: "Imagem", value: "imagem" },
  { title: "Origem", value: "origem" },
  { title: "Título", value: "titulo" },
  { title: "Largura", value: "largura", isNum: true },
  { title: "Páginas", value: "paginas" },
  { title: "Sinopse", value: "sinopse" },
  { title: "Tiragem", value: "tiragem" },
  { title: "Espessura", value: "espessura", isNum: true },
  { title: "Subtítulo", value: "subtitulo" },
  { title: "Título - En", value: "titulo_en" },
  { title: "Título - Es", value: "titulo_es" },
  { title: "Ano edição", value: "ano_edicao" },
  { title: "Preço capa", value: "preco_capa", isNum: true },
  { title: "Sinopse - En", value: "sinopse_en" },
  { title: "Sinopse - Es", value: "sinopse_es" },
  { title: "Peso líquido", value: "peso_liquido", isNum: true },
  { title: "Data situação", value: "data_situacao" },
  { title: "Número edição", value: "numero_edicao" },
  { title: "Blacklist Veja", value: "blacklist_veja" },
  { title: "Unidade de medida", value: "unidade_medida" },
  { title: "Barras de edição antiga", value: "barras_edicao_antiga" },
  { title: "Idioma", value: "idioma", isObj: true },
  { title: "Bisac assunto", value: "bisac_assunto", isObj: true },
  { title: "Bisac categoria", value: "bisac_categoria", isObj: true },
  { title: "Área Bookinfo", value: "categoria_bookinfo", isObj: true },
  { title: "Área PublishNews", value: "categoria_publishnews", isObj: true },
  { title: "Área Veja", value: "categoria_veja", isObj: true },
  { title: "Categoria", value: "categoria_erp", isObj: true }, 
  { title: "Encadernação", value: "encadernacao", isObj: true },
  { title: "Situação", value: "situacao", isObj: true },
  { title: "Editora", value: "editora", isObj: true },
  { title: "Data Alteração", value: "dta_alteracao" },
];

// tslint:disable-next-line:no-empty-interface
export interface IProductModalProps {
  produto: any;
  loading: boolean;
  viewProduto?: string;
  onClose(): void;
}

// tslint:disable-next-line:no-empty-interface
export interface IProductModalState {}

export class ProductModal extends React.Component<
  IProductModalProps,
  IProductModalState
> {
  constructor(props: IProductModalProps) {
    super(props);
  }

  public render() {
    const { loading, produto, onClose, viewProduto } = this.props;

    return (
      <Dialog
        open={!!viewProduto}
        onClose={onClose}
        PaperProps={{ style: { width: "900px", maxWidth: "900px" } }}
      >
        {loading ? (
          <LinearProgress />
        ) : (
          <>
            <div className="title">
              <DialogTitle title={produto.payload.titulo}>{!!produto.payload.titulo ? produto.payload.titulo : viewProduto}</DialogTitle>
              <IconButton onClick={onClose}><Close /></IconButton>
            </div>
            <DialogContent>
              <div className="body">{this.getFields(produto.payload, produto.dta_alteracao)}</div>
              <div className="footer-body">
                <div className="autores-table">
                  {!!produto.payload.autores && (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Nome do autor</TableCell>
                          <TableCell>Sobrenome do autor</TableCell>
                          <TableCell>Tipo do autor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {produto.payload.autores.map((row: any) => (
                          <TableRow key={this.getKey()}>
                            <TableCell>{row.nome_autor}</TableCell>
                            <TableCell>{row.sobrenome_autor}</TableCell>
                            <TableCell>{`${row.id_tipo_autor} - ${row.tipo_autor}`}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  )}
                </div>
                {!!produto.url_imagem && (
                  <div>
                    <img src={`${IMAGES_URL}${produto.url_imagem}`} />
                  </div>
                )}
              </div>
            </DialogContent>
          </>
        )}
      </Dialog>
    );
  }

  private getFields(payload: any[], dtaAlteracao: string) {
    const campos: React.ReactNode[] = [];
    payloadBody.map((prop) => {
      const title = prop.title;
      const valor = prop.value === 'dta_alteracao' ? dtaAlteracao : this.getValue(prop, payload[prop.value]);
      campos.push(this.getField(title, valor));
    });
    return campos;
  }

  private getField(label: string, value?: any) {
    return (
      <TextField
        key={this.getKey()}
        label={label}
        value={value || ""}
        title={value}
        inputProps={{ readOnly: true }}
        fullWidth={true}
        type="text"
      />
    );
  }

  private getValue = (prop: IPayloadProps, value?: any) => {
    if (!!prop.isObj && this.isObj(value)) {
      if (!!value.descricao && !!value.id && !!value.descricao.descricao) {
        return `${value.id} - ${value.descricao.descricao}`
      }
      return `${value.id} - ${value.descricao}`;
    }
    if (!!prop.isNum && this.isNum(value)) {
      return Number.parseFloat(value).toFixed(2);
    }
    return value;
  };

  private isObj(valor: any) {
    return !!valor && !!valor.id && !!valor.descricao;
  }

  private isNum(valor: any) {
    return !!valor && !!Number.parseFloat(valor);
  }

  private getKey = () => {
    return Math.random() * 12;
  };
}



// WEBPACK FOOTER //
// ./src/component/administration/registers/product-grid/ProductModal.tsx